import React from 'react'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


import ivImage01 from '../../../images/Products/IR_Lighting/IN-90X_08.webp'
import ivImage02 from '../../../images/Products/IR_Lighting/IN-90X_10.webp'

export default function ImageCard() {

  return (
    <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
      <EuiFlexItem>
        <EuiCard
          image={
            <div>
              <img
                src={ivImage01}
                alt="INSTAR Infrared Spotlights"
              />
            </div>
          }
          footer={
            <EuiText>
              <p>The sensor response for incident light at a higher wavelength is greatly reduced, resulting in lower sensitivity to LEDs at 940 nm and a shorter range for these headlamps.</p>
            </EuiText>
          }
        />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiCard
          image={
            <div>
              <img
                src={ivImage02}
                alt="INSTAR Infrared Spotlights"
              />
            </div>
          }
          footer={
            <EuiText>
              <p>Air also tends to work against us at higher wavelengths - opacity increases rapidly and reduces the range you will achieve with a 940nm light source, especially outdoors.</p>
            </EuiText>
          }
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
}
